import { InjectionToken } from '@angular/core';
import { AppInsightsConfigModel } from '@omaxel/angular-ms-app-insights';
import { AuthConfig } from 'angular-oauth2-oidc';

export interface Environment {
    production: boolean;
    apiUrl: string;
    logging: AppInsightsConfigModel;
    auth?: AuthConfig;
    version: string;
    clarityProjectId?: string;
    enableDevModule?: boolean;
}

export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT');
